"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
const mithril_1 = __importDefault(require("mithril"));
const helpers_1 = require("../utils/helpers");
let timeout;
exports.Dropdown = {
    divider() {
        return (0, mithril_1.default)("hr", { class: "dropdown-divider" });
    },
    linkItem(content, onclick, isActive = false) {
        return (0, mithril_1.default)("a", {
            href: "#",
            onclick: (evt) => { evt.preventDefault(); onclick(evt); },
            class: `dropdown-item ${isActive && "is-active"}`
        }, content);
    },
    item(content) {
        return (0, mithril_1.default)("div", { class: "dropdown-item" }, content);
    },
    view(vnode) {
        let active = vnode.attrs.active ? "is-active" : "";
        let onclick = vnode.attrs.onclick || (() => { });
        let text = vnode.attrs.text;
        text = text || "Dropdown";
        text = [text, vnode.attrs.active ? (0, helpers_1.iconSpan)("fa-times") : (0, helpers_1.iconSpan)("fa-angle-down")];
        let optsTrigger = {
            class: "dropdown-trigger",
            "aria-haspopup": "true",
            "aria-controls": "dropdown-menu"
        };
        return (0, mithril_1.default)("div", { class: `dropdown ${active}` }, (0, mithril_1.default)("div", optsTrigger, (0, mithril_1.default)("button", {
            class: "button",
            onclick: () => { onclick(!vnode.attrs.active); }
        }, text)), (0, mithril_1.default)("div", { class: "dropdown-menu", role: "menu" }, (0, mithril_1.default)("div", {
            class: "dropdown-content",
            onfocus: () => {
                window.clearTimeout(timeout);
            }
        }, vnode.children)));
    }
};
